// Escapa caracteres especiais de HTML em texto livre digitado pelo usuário
// antes de interpolar em strings que serão renderizadas via
// dangerouslySetInnerHTML. Nunca aplicar a fragmentos que já são HTML
// confiável (gerado pelo próprio sistema a partir de texto já escapado).
export const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export default escapeHtml;
